
import {
  defineComponent, ref, onMounted,
} from 'vue';
import SvgIcon from '@/components/SvgIcon.vue';
// import '@/assets/icons/fire.svg';
// import '@/assets/icons/download.svg';
// import '@/assets/icons/startCase.svg';
import { LockOutlined } from '@ant-design/icons-vue';
import { Popover } from 'ant-design-vue';
import cardListVue from '@/components/student/cardList.vue';
import { getUuid, Uuid } from '@/lib';
import useConfigHooks from '@/hooks/config.hooks';
import { CardDataImpl } from '@/interface/config.interface';
import { useLateralRoll } from '@/lib/lateralRoll';
import { baseURL } from '@/axios/fetch';
import useUserHooks from '@/hooks/user.hooks';
import { useRouter } from 'vue-router';

export default defineComponent({
  components: {
    SvgIcon,
    LockOutlined,
    aPopover: Popover,
    cardListVue,
  },
  props: {},
  setup() {
    const userHooks = useUserHooks();
    const configHooks = useConfigHooks();
    const router = useRouter();
    const dataList = ref<Uuid<CardDataImpl>[]>([]);
    const init = async () => {
      dataList.value = getUuid(await configHooks.getStuHomepageData());
    };
    const handleClick = (item: CardDataImpl) => {
      if (item.caseData?.caseInfo.packageName === 'analysisPage') {
        router.push({
          path: '/Student/analysis',
        });
      } else if (item.caseData?.caseInfo.registryName) {
        const { registryName } = item.caseData.caseInfo;
        window.location.href = `${registryName}://${baseURL}_${userHooks.getUserInfo().code}`;
        setTimeout(() => {
          router.push({
            path: '/Student/resourceDownload',
          });
        }, 2000);
      }
    };

    onMounted(async () => {
      await init();
      useLateralRoll(document.getElementById('cardListVue')!);
    });
    return {
      dataList,
      handleClick,
    };
  },
});
